import { formatCnpj } from '@mais-retorno-front/libs/util-helpers';
import { DEFAULT_ROUTES } from './routes';

const ROOT_ROUTE = process.env.NEXT_PUBLIC_DOMAIN;

export const OG_TYPE_ARTICLE = 'article';

export const HOME_SEO = {
  baseUrl: 'https://maisretorno.com/',
  pageTitle: 'Mais Retorno | Comparador de Fundos, Notícias e mais',
  pageDescription:
    'Comparações de ativos, simulações de investimentos, consolidação de carteira e muitas outras ferramentas para você investir melhor.',
};

export const TERMS_OF_USE_SEO = {
  baseUrl: `https://maisretorno.com/termos-de-uso`,
  pageTitle: 'Termos de Uso | Mais Retorno',
  pageDescription:
    'Termos de uso do site Mais Retorno. Acesse e confira nossas políticas.',
};

export const LOGIN_SEO = {
  baseUrl: 'https://maisretorno.com/login',
  pageTitle: 'Login | Mais Retorno',
  pageDescription:
    'Faça login e acesse ferramentas exclusivas da mais retorno.',
};

export const LATEST_NEWS_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.latestNews}`,
  pageTitle: 'Confira as últimas notícias',
  pageDescription:
    'Lista das últimas matérias e conteúdos relacionados lançados na Mais Retorno',
};

export const VIDEOS_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.videos}`,
  pageTitle: 'Arquivo Videos',
  pageDescription:
    'Visite todos os videos sobre investimentos, finanças e economia da Mais Retorno',
};

export const AUTHOR_SEO = {
  baseUrl: (authorSlug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.authorPage}/${authorSlug}`,
  pageTitle: (authorName: string) =>
    `${authorName} | Equipe Editorial Mais Retorno`,
  pageDescription: (authorName: string) =>
    `Confira as principais notícias do autor(a) ${authorName}. Acesse o site da Mais Retorno e confira!`,
};

export const TAGS_SEO = {
  baseUrl: (tagSlug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.tags}/${tagSlug}`,
  pageTitle: (tagName: string) => `Tudo sobre ${tagName}`,
  pageDescription: (tagName: string) =>
    `Lista de matérias, conteúdos relacionados e tudo sobre ${tagName}.`,
};

export const TERMS_SEO = {
  baseUrl: (tagSlug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.terms}/${tagSlug}`,
  pageTitle: (letter: string) =>
    `Termos do mercado financeiro iniciados com ${letter}`,
  pageDescription: (tagName: string) =>
    `Lista de matérias, conteúdos relacionados e tudo sobre ${tagName}.`,
};

export const PODCAST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.podcast}`,
  pageTitle: 'Retornocast',
  pageDescription:
    'Confira todos os podcasts sobre investimentos, finanças e economia da Mais Retorno',
};

export const NEWS_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.categories}/${slug}`,
  pageTitle: (category: string) =>
    `Notícias sobre ${category} | Categoria do Portal Mais Retorno`,
  pageDescription: (category: string) =>
    `Confira as principais notícias sobre ${category} no portal da Mais Retorno. Notícias do Mercado Financeiro em tempo real e coberturas exclusivas.`,
};

export const MANAGER_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.managerListFund}`,
  pageTitle: 'Gestores de Fundos de Investimentos do Brasil',
  pageDescription:
    'Lista de todos gestores de fundos de investimentos do Brasil, saiba o patrimônio, quantidade de cotistas e saiba quais fundos cada um deles faz gestão.',
};

export const MANAGER_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.managerListFund}/${slug}`,
  pageTitle: (nicename: string, cnpj: number) =>
    `Gestor (a) ${nicename} - ${formatCnpj(cnpj)}`,
  pageDescription: (nicename: string, cnpj: number) =>
    `Gestora ${nicename}, sob CNPJ ${formatCnpj(
      cnpj
    )}. Saiba quem são os gestores, o endereço, site, além do patrimônio da gestora, quantidade de cotistas e mais.`,
};

export const MANAGER_FUNDS_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.managerListFund}/${slug}/fundos`,
  pageTitle: (nicename: string, cnpj: number) =>
    `Fundos sob gestão de ${nicename} - ${formatCnpj(cnpj)}`,
  pageDescription: (nicename: string, cnpj: number) =>
    `Conheça todos os fundos sob gestão de ${nicename}, CNPJ - ${formatCnpj(
      cnpj
    )} e veja a lâmina atualizada com todas informações de cada um dos fundos.`,
};

export const MANAGER_FUNDS_PAGINATED_SEO = {
  baseUrl: (slug: string, page: number) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.managerListFund}/${slug}/fundos${
      page > 1 ? '/page/' + page : ''
    }`,
  pageTitle: (nicename: string, cnpj: number, page: number) =>
    `Fundos sob gestão de ${nicename} - ${formatCnpj(cnpj)} | Página ${page}`,
  pageDescription: (nicename: string, cnpj: number, page: number) =>
    `Conheça todos os fundos sob gestão de ${nicename}, CNPJ ${formatCnpj(
      cnpj
    )} e veja a lâmina atualizada com todas informações de cada um dos fundos. | Página ${page}.`,
};

export const ADMINISTRATOR_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.adminListFunds}`,
  pageTitle: 'Administradores de Fundos de Investimentos do Brasil',
  pageDescription:
    'Lista de todos administradores de fundos de investimentos do Brasil, saiba o patrimônio, quantidade de cotistas e saiba quais fundos cada um deles faz administração.',
};

export const ADMINISTRATOR_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.adminListFunds}/${slug}`,
  pageTitle: (nicename: string, cnpj: number) =>
    `${nicename} - ${formatCnpj(cnpj)}.`,
  pageDescription: (nicename: string, cnpj: number) =>
    `Conheça a administradora de recursos ${nicename}, sob CNPJ ${formatCnpj(
      cnpj
    )}. Saiba quem são os responsáveis pela empresa, o patrimônio, cotistas e muito mais.`,
};

export const ADMINISTRATOR_FUNDS_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.adminListFunds}/${slug}/fundos`,
  pageTitle: (nicename: string, cnpj: number) =>
    `Fundos administrados por ${nicename} - ${formatCnpj(cnpj)}.`,
  pageDescription: (nicename: string, cnpj: number) =>
    `Conheça os fundos administrados por ${nicename}, sob CNPJ ${formatCnpj(
      cnpj
    )} e veja a lâmina atualizada com todas informações de cada um dos fundos.`,
};

export const ADMINISTRATOR_FUNDS_PAGED_SEO = {
  baseUrl: (slug: string, page: number) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.adminListFunds}/${slug}/fundos${
      page > 1 ? '/page/' + page : ''
    }`,
  pageTitle: (nicename: string, cnpj: number, page: number) =>
    `Fundos administrados por ${nicename} - ${formatCnpj(
      cnpj
    )} | Página ${page}`,
  pageDescription: (nicename: string, cnpj: number, page: number) =>
    `Conheça os fundos administrados por ${nicename}, sob CNPJ ${formatCnpj(
      cnpj
    )} e veja a lâmina atualizada com todas informações de cada um dos fundos | Página ${page}.`,
};

export const SEARCH_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.unifiedSearch}/${slug}`,
  pageTitle: (name: string) => `Busca por ${name} | Mais Retorno`,
  pageDescription: (name: string) =>
    `Confira os resultados da busca por ${name}`,
};

export const FUND_SEARCH_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.filterFunds}`,
  pageTitle: 'Resultados da busca',
  pageDescription:
    'Pesquise e faça uma busca por todos os fundos disponíveis no Brasil, se preferir também é possível encontrar fundos por rentabilidade, volatilidade, patrimônio entre outros itens.',
};

export const HOME_FUND_COMPARISON_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.comparisonFund}`,
  pageTitle: 'Comparação de Fundos de Investimentos | Mais Retorno',
  pageDescription:
    'Comparação de fundos com histórico de rentabilidade, volatilidade, sharpe, patrimônio e mais! O melhor comparador de investimentos (grátis)!',
};

export const HOME_GLOSSARY_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.glossary}`,
  pageTitle: 'Glossário de Finanças e Investimentos | Mais Retorno',
  pageDescription:
    'Entenda os conceitos e termos utilizados em finanças, investimentos, economia e o merado financeiro em geral no dicionário financeiro mais completo!',
};

export const HOME_PORTAL_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.portalBaseUrl}`,
  pageTitle:
    'Notícias sobre os acontecimentos no mundo do investimento e seus impactos | Mais Retorno.',
  pageDescription: `Acesse as notícias gratuitas sobre Mercado Financeiro, Renda Fixa, Renda Variável e Econômia. Fique por dentro de tudo que acontece no mundos dos investimentos!`,
};

export const CONTENT_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.evergreenHome}`,
  pageTitle: 'Conteúdo | Mais Retorno',
  pageDescription:
    'Acesse ferramentas e informações gratuitas de alto nível sobre Comparação de Fundos de Investimentos, Renda Fixa e Renda Variável. Conte com a gente para acelerar o resultado dos seus investimentos!',
};

export const FUND_SEO = {
  baseUrl: (canonical: string) => `${ROOT_ROUTE}${canonical}`,
  pageTitle: (name: string, cnpj: number | string | null) =>
    `Fundo ${name} ${cnpj ? `- ${formatCnpj(cnpj)}` : ''}`,
  pageDescription: (name: string, cnpj: number | string) =>
    `Fundo ${name} - ${formatCnpj(
      cnpj
    )}. Acompanhe a rentabilidade, saiba a quantidade de cotistas, patrimônio e mais.`,
};

export const CRYPTO_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.sheetCrypto}/${slug}`,
  pageTitle: (name: string) => `${name} | Mais Retorno`,
  pageDescription: (name: string) =>
    `Acompanhe a cotação, rentabilidade, volatilidade, sharpe e mais sobre ${name}.`,
};

export const FUND_WALLET_SEO = {
  baseUrl: (slug: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.sheetFunds}/${slug}/carteira`,
  pageTitle: (fundName: string, cnpj: number) =>
    `Carteira do fundo ${fundName} - ${formatCnpj(cnpj)}`,
  pageDescription: (fundName: string, cnpj: number, fundManagerName) =>
    `Veja a carteira completa e saiba onde investe o fundo ${fundName} - CNPJ ${formatCnpj(
      cnpj
    )}, da gestora ${fundManagerName}.`,
};

export const FUND_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.filterFunds}`,
  pageTitle: '📈 Lista de todos Fundos de Investimentos',
  pageDescription:
    'Pesquise e faça uma busca por todos os fundos disponíveis no Brasil, se preferir também é possível encontrar fundos por rentabilidade, volatilidade, patrimônio entre outros itens.',
};

export const SCREENER_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.fundTracker}`,
  pageTitle: 'Rastreador de Fundos | Mais Retorno',
  pageDescription:
    'Pesquise por todos os fundos disponíveis no Brasil, se preferir também é possível encontrar fundos por rentabilidade, volatilidade, patrimônio e muito mais.',
};

export const ASSET_COMPARISON_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.assetsComparison}`,
  pageTitle: 'Comparador de ativos | Mais Retorno',
  pageDescription:
    'Comparação entre Fundos, FIIs, Ações, Renda fixa, BDR`s entre outros... Com histórico de rentabilidade, volatilidade, sharpe e mais!',
};

export const PORTFOLIO_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.portfolio}`,
  pageTitle: 'Consolidador de Carteira | Mais Retorno',
  pageDescription:
    'Consolide seus investimentos em um só lugar. Acompanhe a rentabilidade, volatilidade, sharpe e mais!',
};

export const BOOKMARK_COMPARISON_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.bookmarkComparison}`,
  pageTitle: 'Comparações salvas | Mais Retorno',
  pageDescription: 'Encontre as suas comparações salvas.',
};

export const BOOKMARK_CONTENT_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.bookmarkContent}`,
  pageTitle: 'Conteúdo salvo | Mais Retorno',
  pageDescription: 'Encontre suas matérias, videos e podcasts salvos.',
};

export const BOOKMARK_FUND_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.bookmarkFund}`,
  pageTitle: 'Fundos favoritos | Mais Retorno',
  pageDescription: 'Encontre seus fundos favoritos.',
};

export const PROFILE_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.userProfile}`,
  pageTitle: 'Minha conta | Mais Retorno',
  pageDescription: 'Atualize suas informações de perfil e mais.',
};

export const INTEGRATIONS_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.userConnections}`,
  pageTitle: 'Integrações | Mais Retorno',
  pageDescription: 'Conecte sua carteira',
};

export const UPDATE_PAYMENT_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.updatePaymentMethod}`,
  pageTitle: 'Editar Pagamento | Mais Retorno',
  pageDescription: 'Atualize suas informações de cobrança.',
};

export const SUBSCRIPTION_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.userSubscription}`,
  pageTitle: 'Minhas assinaturas | Mais Retorno',
  pageDescription: 'Visualize informações sobre seus planos e assinaturas.',
};

export const INCOME_SIMULATOR_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.incomeSimulation}`,
  pageTitle: 'Simulador de carteira | Mais Retorno',
  pageDescription:
    'Simulador de investimentos... Com histórico de rentabilidade, volatilidade, sharpe e mais!',
};

export const SHEET_INCOME_SIMULATOR_SEO = {
  baseUrl: (sheetIdentifier: string) =>
    `${ROOT_ROUTE}${DEFAULT_ROUTES.incomeSimulation}/${sheetIdentifier}`,
  pageTitle: 'Lâmina - Simulador de carteira | Mais Retorno',
  pageDescription:
    'Lâmina do simulador de carteira... Com histórico de rentabilidade, volatilidade, sharpe e mais!',
};

export const DASHBOARD_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.dashboard}`,
  pageTitle: 'Dashboard | Mais Retorno',
  pageDescription: 'Acesse todas as ferramentas e informações do seu perfil.',
};

export const CREATE_INCOME_SIMULATOR_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.createIncomeSimulation}`,
  pageTitle: 'Nova Simulação de carteira | Mais Retorno',
  pageDescription:
    'Simulador de carteira... Com histórico de rentabilidade, volatilidade, sharpe e mais!',
};

export const STOCK_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.stocksList}`,
  pageTitle:
    'Lista Completa das Ações listadas na bolsa de valores B3 (Bovespa) | Mais Retorno',
  pageDescription:
    'Tudo sobre as ações listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const STOCK_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre a ação ${name.toUpperCase()}: gráficos, cotações, proventos, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const TREASURY_DIRECT_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.treasuryDirectList}`,
  pageTitle: 'Tesouro Direto',
  pageDescription:
    'Tudo sobre tesouro direto. Veja a cotação histórica, rentabilidade, taxas, duration, gráfico, histórico de preço e muito mais.',
};

export const TREASURY_DIRECT_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) => `${name}: Gráfico e histórico de preço`,
  pageDescription: (name: string) =>
    `${name}: Veja a cotação histórica, rentabilidade, taxas, duration, gráfico, histórico de preço e muito mais. Acesse!`,
};

export const PUBLIC_TITLE_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.publicTitleList}`,
  pageTitle: 'Títulos Públicos',
  pageDescription:
    'Tudo sobre títulos públicos. Veja a cotação histórica, rentabilidade, taxas, duration, gráfico, histórico de preço e muito mais.',
};

export const PUBLIC_TITLE_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) => `${name}: Gráfico e histórico de preço`,
  pageDescription: (name: string) =>
    `${name}: Veja a cotação histórica, rentabilidade, taxas, duration, gráfico, histórico de preço e muito mais. Acesse!`,
};

export const FII_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o fundo imobiliário ${name.toUpperCase()}: gráficos, cotações, dividendos, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const ETF_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o ETF ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const BDR_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o BDR ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const FIAGRO_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o FIAGRO ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const FIP_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o FIP ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const INDEXES_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o índice ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const FI_INFRA_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre o FI-Infra ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const DEBENTURES_SEO = {
  baseUrl: (canonical_url: string) => `${ROOT_ROUTE}/${canonical_url}`,
  pageTitle: (name: string) =>
    `${name.toUpperCase()}: cotação e indicadores | Mais Retorno`,
  pageDescription: (name: string) =>
    `Tudo sobre a debênture ${name.toUpperCase()}: gráficos, cotações, resultados, análises, notícias, fatos relevantes e mais. Acesse!`,
};

export const FII_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.fiiList}`,
  pageTitle:
    'Lista Completa dos Fundos Imobiliários listados na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre os fundos imobiliários listados na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const BDR_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.bdrList}`,
  pageTitle: 'Lista Completa de BDRs listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre as BDRs listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const ETF_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.etfList}`,
  pageTitle: 'Lista Completa de ETFs listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre as ETFs listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const FIAGRO_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.fiagroList}`,
  pageTitle:
    'Lista Completa de FIAGROs listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre os FIAGROs listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const FIP_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.fipList}`,
  pageTitle: 'Lista Completa de FIPs listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre os FIPs listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const FI_INFRA_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.fiInfrapList}`,
  pageTitle:
    'Lista Completa de FI-Infras listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre os FI-Infras listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const DEBENTURES_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.debenturesList}`,
  pageTitle:
    'Lista Completa de debêntures listadas na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre as debêntures listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const INDEX_LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.indexesList}`,
  pageTitle:
    'Lista Completa de índices listados na bolsa de valores B3 (Bovespa)',
  pageDescription:
    'Tudo sobre os índices listadas na bolsa de valores (B3). Veja cotações, indicadores e muito mais.',
};

export const LIST_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.list}`,
  pageTitle:
    'Todas as listagens de ativos do mercado financeiro! | Mais Retorno',
  pageDescription:
    'Veja todas as listas de ativos do mercado financeiro! Veja lista de fundos, ações, fundos imobiliários, BDRs, ETFs, títulos públicos e tesouro direto e muito mais.',
};

export const RANKING_SEO = {
  baseUrl: `${ROOT_ROUTE}${DEFAULT_ROUTES.rankingFund}`,
  pageTitle: 'Melhores Fundos de Investimentos | Mais Retorno',
  pageDescription:
    'Ranking dos Melhores Fundos de Investimentos, com lâmina, rentabilidade, cotação atualizada diariamente, estatísticas e muito mais!',
};
